// Replace with your Firebase config
export const firebaseConfig = {
  apiKey: "AIzaSyCR9Fn3Yx2sbTtDYsiJxM2tY-gSmPF-UOI",
  authDomain: "diana-bf05d.firebaseapp.com",
  databaseURL: "https://diana-bf05d-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "diana-bf05d",
  storageBucket: "diana-bf05d.appspot.com",
  messagingSenderId: "1098088986325",
  appId: "1:1098088986325:web:6e2f925d60f65d6a76145c",
  measurementId: "G-8GQQ4JR0SL"
};



export const firebaseConfigSandbox = {
  apiKey: "AIzaSyAC1XWiwvkeAyQNfXNt2BM6yqpw_WnxTNQ",
  authDomain: "diana-sandbox-ee2ba.firebaseapp.com",
  databaseURL: "https://diana-sandbox-ee2ba-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "diana-sandbox-ee2ba",
  storageBucket: "diana-sandbox-ee2ba.appspot.com",
  messagingSenderId: "990272935572",
  appId: "1:990272935572:web:4deed20f036113c8b38681",
  measurementId: "G-W7E925Q5DX"
};